module.exports = __webpack_public_path__ + "static/img/strona_037.2c93bb7f.jpg";